import axios from 'axios';

import { isClientPFINC, isCrmEnabled } from '../../../../utils/Helpers';
import {
  CUBEJS_BASE_URL,
  CUBEJS_BETA_BASE_URL,
} from '../../../../config/variables';
import { CONFIG } from '../../../../constants';
import { URL_CONSTANTS } from '../../../../constants/urlConstants';
import ApiService from '../../../../services/api.service';
import { REACT_APP_ENABLE_CUBEJS_BETA } from '../../../../constants/envConstants';

export const getDataSource = async () => {
  try {
    const excludeCubesList = [
      'ProjectTaskNotes',
      'TaskNotes',
      'ProjectTasks',
      'OpportunitySource',
      'OpportunityStatus',
      'OpportunityTemperature',
      'QuoteTemperature',
      'QuoteStatus',
      'ItemTypes',
      'QuotesLineItem',
      'QuotesNote',
      'ChargebackReasons',
      'ChargebackStatus',
      'CreditUser',
      'DebitUser',
      'CreatedBy',
      'UpdatedBy',
      'ChargebackPaymentCategories',
      'CrewTypes',
      'RetainageTypes',
      'RetainageCategories',
      'RetainagePaymentCategories',
      'SupportTicketPriority',
      'SupportTicketType',
      'SupportTicketStatus',
      'SupportTicketSla',
    ];
    if (!isCrmEnabled()) {
      excludeCubesList.push(
        'Opportunity',
        'OpportunitySource',
        'OpportunityStatus',
        'Quotes'
      );
    }

    if (!isClientPFINC()) {
      excludeCubesList.push('SupportTicket');
    }

    const response = await axios.get(
      `${URL_CONSTANTS.API.BASE_URL}/dashboard/widgets/cubes`
    );
    return (
      (response?.data?.length &&
        response?.data?.filter(
          record => !excludeCubesList.includes(record.name)
        )) ||
      []
    );
  } catch (error) {
    console.log(error);
  }
};

export const getQueryResult = async (
  query,
  _formikValues = null,
  isSupportClient = false,
  widgetId
) => {
  const isSpecialPFUser = JSON.parse(
    localStorage.getItem('isSpecialPFUser') ?? 'false'
  );
  const betaEnabled =
    isSpecialPFUser && REACT_APP_ENABLE_CUBEJS_BETA === true
      ? JSON.parse(localStorage.getItem('betaTestEnabled'))
      : false;
  try {
    if (query?.dimensions?.[0] || query?.measures?.length) {
      if (query.dimensions) {
        query.dimensions = query?.dimensions?.filter(
          dimension => dimension != null && dimension !== ''
        );
      }
      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${CUBEJS_BASE_URL}/load/`,
        headers: {
          'client-id': isSupportClient
            ? 'support'
            : localStorage.getItem('client_id'),
          Authorization: localStorage.getItem('cubejsAuthorizationToken'),
          'Content-Type': 'application/json',
          ...(widgetId && {
            'widget-id': widgetId,
          }),
        },
        data: JSON.stringify({
          query: query,
        }),
      };

      if (betaEnabled) {
        config.url = `${CUBEJS_BETA_BASE_URL}/load/`;
        config.headers['Authorization'] =
          `Bearer ${localStorage.getItem('access_token')}`;
      }
      const response = await axios.request(config);
      return response?.data || [];
    }
    return {};
  } catch (error) {
    console.log(error);
  }
};

export const createWidget = async payload => {
  const response = await axios.post(
    `${URL_CONSTANTS.API.BASE_URL}/dashboard/widget-templates`,
    payload
  );
  return response;
};

export const editWidget = async (payload, id) => {
  const response = await axios.patch(
    `${URL_CONSTANTS.API.BASE_URL}/dashboard/widget-templates/${id}`,
    payload
  );
  return response;
};

export const getDataByCube = async (cubeName, dimensionName) => {
  if (
    ['Opportunity'].includes(cubeName) &&
    ['source_id'].includes(dimensionName)
  ) {
    const response = await axios.get(
      `${URL_CONSTANTS.CRM.baseUrl}/api/master-data/cube?cube=${cubeName}&dimension=${dimensionName}`
    );
    return response.data;
  } else {
    const response = await axios.get(
      `${URL_CONSTANTS.API.BASE_URL}/system/cubes/master?cube=${cubeName}&dimension=${dimensionName}`
    );
    return response?.data;
  }
};

export const getFilterDetails = async () => {
  try {
    const response = await axios.get(
      `${URL_CONSTANTS.API.BASE_URL}/dashboard/widgets/filter-type`
    );
    return response?.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const getWidgetDataById = async id => {
  const response = await axios.get(
    `${URL_CONSTANTS.API.BASE_URL}/dashboard/widget-templates/${id}`
  );
  return response?.data;
};

export const getProjectDetails = async projectTaskId => {
  let apiUrl = `${CONFIG.API_BASE_URL}/projects/${projectTaskId}`;
  try {
    const response = await axios.get(apiUrl);
    if (response) {
      return response?.data;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const getDashboardList = async (searchQuery, setDashboardListData) => {
  try {
    const newQueryString = Object.entries(searchQuery)
      .filter(([, value]) => Boolean(value) || value === 0)
      .map(([key, value]) => `${key}=${value}`)
      .join('&');
    const response = await axios.get(
      `${CONFIG.API_BASE_URL}/dashboard/manage/list/available-dashboards?${newQueryString}`
    );
    setDashboardListData(response.data?.items);
  } catch (error) {
    console.log(error);
  }
};

export const storeDashboardAnalysis = () => {
  // ApiService.postWithDiffBaseUrl(
  //   '/dashboard-performance',
  //   payload,
  //   URL_CONSTANTS.ANALYTICS.baseUrl
  // );
};

export const fetchWarehouseList = async () => {
  try {
    const response = await ApiService.get(`/system/master-warehouses/list`);
    return response;
  } catch (error) {
    console.error('Error Occured while Fetching Warehouse List: ', error);
    return [];
  }
};

export const fetchBinList = async warehouseId => {
  try {
    const response = await ApiService.get(
      `/system/inventory/${warehouseId}/bin-list`
    );
    return response;
  } catch (error) {
    console.error('Error Occured while Fetching Bin List:', error);
    return [];
  }
};

export const updateReceiveInventory = async (projectId, ProductId, payload) => {
  try {
    const response = await ApiService.put(
      `/projects/${projectId}/v1/project-item/${ProductId}/update`,
      payload
    );
    return response;
  } catch (error) {
    console.error(error);
    return {};
  }
};

export const updateReceiveInventoryItem = async (
  projectId,
  ProductId,
  payload
) => {
  try {
    const response = await ApiService.put(
      `/projects/${projectId}/v1/project-item/${ProductId}/update/inventory`,
      payload
    );
    return response;
  } catch (error) {
    console.error(error);
    return {};
  }
};

export const bulkUpdateApiCall = async payload => {
  try {
    const response = await ApiService.patch(
      `/projects/bulk-update/project`,
      payload
    );
    return response;
  } catch (error) {
    console.error(error);
    return {};
  }
};
